import React, { useState, useEffect  } from "react";
import BackToLoginPageButton from "../../../Components/BackToLoginPageButton/BackToLoginPageButton";

const Step1Verification = ({ onNextStep }) => {
  const [agreed1, setAgreed1] = useState(false);
  const [agreed2, setAgreed2] = useState(false);
  const [agreed3, setAgreed3] = useState(false);
  const [agreed4, setAgreed4] = useState(false);
  const [agreedAll, setAgreedAll] = useState(false);
  const allRequiredAgreed = agreed1 && agreed2;
  
  const handleVerification = () => {
    if (!allRequiredAgreed) {
      alert("개인정보 수집 및 이용에 동의해야 합니다.");
      return;
    }
    // TODO: verification API here.
    onNextStep();
  };

  const handleAgreeAllChange = (checked) => {
    setAgreedAll(checked);
    setAgreed1(checked);
    setAgreed2(checked);
    setAgreed3(checked);
    setAgreed4(checked);
  };

  // 전체 동의 상태 반영
  useEffect(() => {
    const allChecked = agreed1 && agreed2 && agreed3 && agreed4;
    setAgreedAll(allChecked);
  }, [agreed1, agreed2, agreed3, agreed4]);

  return (
    <div className="signup-step-content">
      <div className="agreement-section">
        <span>
          회원가입을 위해 필수 항목에 동의해 주세요.          
        </span>
        <span>          
          선택 항목은 마이페이지에서 언제든 변경할 수 있습니다.          
        </span>
        <br></br>
        <a
          href="#"
          className="view-full-text"
          onClick={(e) => {
            e.preventDefault();
            window.open(
              '/privacy-popup',
              'PrivacyPopup',
              'width=800,height=800,resizable=yes,scrollbars=yes'
            );
          }}
        >
          전문보기
        </a>
        <br></br>
        {/* 전체 동의 체크박스 */}
        <div className="agreement-row" style={{ marginTop: '10px', fontWeight: 'bold' }}>
          <input
            type="checkbox"
            id="agreeAll"
            checked={agreedAll}
            onChange={(e) => handleAgreeAllChange(e.target.checked)}
          />
          <label htmlFor="agreeAll">전체 동의(선택 항목 포함)</label>
        </div>
        {/* 개별 항목 */}
        <div className="agreement-row">
          <input
            type="checkbox"
            id="agreement1"
            checked={agreed1}
            onChange={(e) => setAgreed1(e.target.checked)}
          />
          <label htmlFor="agreement1">개인정보 수집 및 이용에 동의합니다. (필수)</label>
        </div>
        <div className="agreement-row">
          <input
            type="checkbox"
            id="agreement2"
            checked={agreed2}
            onChange={(e) => setAgreed2(e.target.checked)}
          />
          <label htmlFor="agreement2">개인정보 처리 위탁에 동의합니다. (필수)</label>
        </div>
        <div className="agreement-row">
          <input
            type="checkbox"
            id="agreement3"
            checked={agreed3}
            onChange={(e) => setAgreed3(e.target.checked)}
          />
          <label htmlFor="agreement3">제3자 정보 제공에 동의합니다. (선택)</label>
        </div>
        <div className="agreement-row">
          <input
            type="checkbox"
            id="agreement4"
            checked={agreed4}
            onChange={(e) => setAgreed4(e.target.checked)}
          />
          <label htmlFor="agreement4">마케팅 정보 수신에 동의합니다. (선택)</label>
        </div>
                
        <span>※ 수신 동의 여부는 마이페이지에서 언제든 변경할 수 있습니다.</span>
        <br></br>
        
      </div>

      <button
        className="primary-action-button"
        onClick={handleVerification}
        disabled={!allRequiredAgreed}
      >
        휴대폰 본인인증
      </button>

      <BackToLoginPageButton />

      {/* <div className="alt-verification-section">
        <h3>휴대폰 본인인증이 어려우실 경우</h3>
        <p>
          본인 명의의 휴대폰이나 아이핀이 없는 경우에도, 수신 가능한 휴대폰
          번호나 이메일을 통해 가입이 가능합니다.
        </p>
        <div className="alt-buttons-container">
          <button className="secondary-action-button">SMS 인증</button>
          <button className="secondary-action-button">이메일 인증</button>
        </div>
      </div> */}
    </div>
  );
};

export default Step1Verification;
